import deephowApiServerWrapper from "@/server/api-server";

export const saveUpdateSkillDue = ({ skillId, requestBody }) =>
  deephowApiServerWrapper("patch", `/v1/playlists/${skillId}/due`, requestBody);
